import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../revvComponents";

const RecipientEditSignBtn = props => {
  const _editSignBtn = () => (
    <span
      className={`recipientdocheader-download-button ${props.className}`}
      data-test="recipientdocheader-decline-button"
      onClick={props.editSign}
      tabIndex="0"
      onKeyDown={() => {}}
      role="button">
      <FontAwesomeIcon
        icon={["far", "fa-pen-to-square"]}
        className="recipientdocheaderbuttons-icon accept-decline-btn"
      />
      {props.usedFor === "DROPDOWN" && "Edit Signature"}
    </span>
  );
  return props.isMobileView ? (
    _editSignBtn()
  ) : (
    <Tooltip
      placement={props.tooltipPlacement}
      align={{
        offset: [0, 4],
      }}
      overlay="Edit how your signature looks">
      {_editSignBtn()}
    </Tooltip>
  );
};

export default RecipientEditSignBtn;
